<form
  autocomplete="off"
  #activityForm="ngForm"
  (keydown.enter)="onEnterKey($event)"
  (keydown.shift.enter)="onEnterKey($event)"
>
  <div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="start center" style="font-weight: 400">
      <mat-checkbox
        fxFlex="50"
        [(ngModel)]="disablePreupdateTrigger"
        [ngModelOptions]="{ standalone: true }"
        matTooltip="{{ 'key_disablePreupdateTriggerDes' | translate }}"
        >{{ 'key_disablePreupdateTrigger' | translate }}</mat-checkbox
      >
      <mat-checkbox
        fxFlex="50"
        [(ngModel)]="disablePostupdateTrigger"
        [ngModelOptions]="{ standalone: true }"
        matTooltip="{{ 'key_disablePostupdateTriggerDes' | translate }}"
        >{{ 'key_disablePostupdateTrigger' | translate }}</mat-checkbox
      >
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      style="font-weight: 400; margin-top: 15px; margin-bottom: 10px"
    >
      <mat-checkbox
        fxFlex="50"
        [(ngModel)]="useRequestorAsActor"
        [ngModelOptions]="{ standalone: true }"
        (change)="onImpersonationChange()"
        matTooltip="{{ 'key_useRequestorAsActorDes' | translate }}"
        >{{ 'key_useRequestorAsActor' | translate }}</mat-checkbox
      >
      <mat-checkbox
        *ngIf="useRequestorAsActor"
        fxFlex="50"
        [(ngModel)]="skipPermissionCheck"
        [ngModelOptions]="{ standalone: true }"
        >{{ 'key_skipPermissionCheck' | translate }}</mat-checkbox
      >
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      style="font-weight: 400; margin-top: 10px; margin-bottom: 10px"
    >
      <mat-checkbox
        fxFlex="50"
        [(ngModel)]="waitForCompletion"
        [ngModelOptions]="{ standalone: true }"
        matTooltip="{{ 'key_waitForCompletionDes' | translate }}"
        >{{ 'key_waitForCompletion' | translate }}</mat-checkbox
      >
    </div>
    <div *ngIf="waitForCompletion" fxLayout="row" fxLayoutAlign="start center">
      <mat-form-field fxFlex="200px">
        <input
          matInput
          type="number"
          min="0"
          [placeholder]="'key_maxWaitTime' | translate"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="maxWaitSeconds"
          (change)="onMaxTimeChange()"
          matTooltip="{{ 'key_maxWaitTimeDes' | translate }}"
        />
      </mat-form-field>
      <mat-form-field fxFlex="auto" style="margin-left: 20px">
        <mat-label>{{ 'key_waitForCompletionMessage' | translate }}</mat-label>
        <input
          matInput
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="waitForCompletionMessage"
        />
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" style="margin-top: 10px">
      <mat-form-field fxFlex="50" style="margin-right: 20px; margin-top: 2.5px">
        <mat-label>{{ 'key_objectType' | translate }}</mat-label>
        <input
          name="txtObjectType"
          matInput
          required
          [(ngModel)]="objectType"
        />
      </mat-form-field>
      <app-editor-text
        name="txtCreationTarget"
        fxFlex="50"
        [(ngModel)]="createdResourceIDTarget"
        [config]="{
          isSimpleValue: true,
          hintLimit: 50,
          customDisplayName: 'key_createdResourceIDTarget',
          updateOn: updateOnBlure,
          validationKey: 'workflow/CreateResource/createdResourceIdTarget'
        }"
        appExpressionValidator
      ></app-editor-text>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      style="margin-top: 10px"
    ></div>
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      style="margin-top: 10px; font-weight: 400; font-size: 14px"
    >
      {{ 'key_attributePopulation' | translate }}
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      class="accent-text-color"
      style="margin-top: 10px; margin-bottom: 20px"
    >
      {{ 'key_addCreationEntriesDesc' | translate }}
    </div>
    <div
      dragula="UPDATERESOURCESENTRIES"
      [(dragulaModel)]="createResourceEntries"
    >
      <div
        *ngFor="let entry of createResourceEntries; let i = index"
        fxLayout="row"
        fxLayoutAlign="start start"
        style="margin-bottom: 10px"
      >
        <mat-icon
          fxFlex="none"
          class="accent-text-color handle"
          style="cursor: pointer; margin-right: 20px; margin-top: 16px"
          >menu</mat-icon
        >
        <app-editor-text
          fxFlex="30"
          style="margin-right: 20px"
          [name]="'txtTargetLookup' + i"
          [(ngModel)]="entry.target"
          [config]="{
            isSimpleValue: true,
            isCode: true,
            hintLimit: 50,
            customDisplayName: 'key_targetAttribute',
            updateOn: updateOnBlure,
            validationKey: 'workflow/CreateResource/target'
          }"
          appExpressionValidator
        ></app-editor-text>
        <app-editor-text
          fxFlex="70"
          [name]="'txtValueExpression' + i"
          [(ngModel)]="entry.valueexpression"
          [config]="{
            isSimpleValue: true,
            isCode: true,
            hintLimit: 50,
            customDisplayName: 'key_valueExpression',
            updateOn: updateOnBlure,
            validationKey: 'workflow/CreateResource/valueExpression'
          }"
          appExpressionValidator
        ></app-editor-text>
        <button
          mat-icon-button
          color="warn"
          fxFlex="none"
          [matTooltip]="'key_delete' | translate"
          style="margin-top: 6px"
          (click)="onRemoveEntry(i)"
        >
          <span class="material-icons-outlined">delete</span>
        </button>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" style="margin-top: 10px">
      <button mat-stroked-button color="primary" (click)="onAddEntry()">
        {{ 'key_addAttribute' | translate }}
      </button>
    </div>
  </div>
</form>
